export const getPaymentDateStyle = (paymentDate) => {
  if (!paymentDate) return {};

  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0); // إعداد الوقت إلى 00:00:00 للمقارنة
  const paymentDateObj = new Date(paymentDate);
  paymentDateObj.setHours(0, 0, 0, 0); // إعداد الوقت إلى 00:00:00 للمقارنة

  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(currentDate.getDate() - 30);
  thirtyDaysAgo.setHours(0, 0, 0, 0); // إعداد الوقت إلى 00:00:00 للمقارنة

  const thirtyOneDaysLater = new Date();
  thirtyOneDaysLater.setDate(currentDate.getDate() + 31);
  thirtyOneDaysLater.setHours(0, 0, 0, 0); // إعداد الوقت إلى 00:00:00 للمقارنة

  if (paymentDateObj < thirtyDaysAgo) {
    return {
      backgroundColor: "rgba(155, 10, 207, 0.2)",
      color: "black",
      padding: "2px 4px",
      borderRadius: "10%",
    };
  } else if (paymentDateObj < currentDate) {
    return {
      backgroundColor: "rgba(255, 0, 0, 0.2)", // لون أحمر
      color: "black",
      padding: "2px 4px",
      borderRadius: "10%",
    };
  } else if (paymentDateObj.getTime() === currentDate.getTime()) {
    return {
      backgroundColor: "rgba(76, 175, 79, 0.2)", // لون أخضر خافت
      color: "black",
      padding: "2px 4px",
      borderRadius: "10%",
    };
  } else if (paymentDateObj > thirtyOneDaysLater) {
    return {
      backgroundColor: "rgba(4, 157, 246, 0.2)", // لون أزرق
      color: "black",
      padding: "2px 4px",
      borderRadius: "10%",
    };
  }

  return {};
};

export const getStatusStyle = (Status) => {
  return Status === "Offline"
    ? {
        backgroundColor: "rgba(4, 157, 246, 0.2)",
        color: "black",
        padding: "2px 4px",
        borderRadius: "10%",
      }
    : {};
};

export const getServerStatusStyle = (ServerStatus) => {
  const status = ServerStatus;
  if (status === "Suspended") {
    return {
      backgroundColor: "rgba(255, 0, 0, 0.2)",
      color: "black",
      padding: "2px 4px",
      borderRadius: "10%",
    };
  } else if (status === "New") {
    return {
      backgroundColor: "rgba(255, 255, 0, 0.2)",
      color: "black",
      padding: "2px 4px",
      borderRadius: "10%",
    };
  } else {
    return {};
  }
};

export const getRedLightBulbStyle = () => {
  return {
    display: 'inline-block',
    width: '8px',
    height: '8px',
    backgroundColor: '#ff0000',
    borderRadius: '50%',
    marginLeft: '8px',
    boxShadow: 
      '0 0 8px #ff0000, 0 0 16px #ff0000, inset 2px 2px 4px rgba(255, 255, 255, 0.3), inset -2px -2px 4px rgba(0, 0, 0, 0.3)',
    animation: 'blinkRed 1s ease-in-out infinite',
    position: 'relative',
    border: '1px solid rgba(255, 0, 0, 0.5)',
    background: 'radial-gradient(circle at 30% 30%, #ff6666, #ff0000, #cc0000)'
  };
};

export const getSpeechActiveStyle = (speechActive) => {
  if (speechActive === 1 || speechActive === true) {
    return {
      backgroundColor: "rgba(0, 255, 0, 0.3)",
      color: "black",
      padding: "2px 4px",
      borderRadius: "10%",
      fontWeight: "bold",
    };
  } else {
    return {
      color: "black",
      padding: "2px 4px",
      borderRadius: "10%",
      fontWeight: "bold",
    };
  }
};

// دالة لإنشاء تأخير عشوائي ثابت بناءً على نص معين
const getRandomDelay = (seed) => {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    const char = seed.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  // إرجاع قيمة بين 0 و 1 ثانية
  return Math.abs(hash % 1000) / 1000;
};

export const getLoginStatusLightBulbStyle = (lastLogin, customerIdentifier = '') => {
  // إنشاء تأخير عشوائي ثابت لكل عميل
  const delay = getRandomDelay(customerIdentifier || 'default');
  
  if (!lastLogin) {
    // برتقالي مصفر إذا لم يكن هناك آخر دخول (لم يدخل أبداً)
    return {
      display: 'inline-block',
      width: '8px',
      height: '8px',
      backgroundColor: '#ffa500',
      borderRadius: '50%',
      marginLeft: '8px',
      boxShadow: 
        '0 0 8px #ffa500, 0 0 16px #ffa500, inset 2px 2px 4px rgba(255, 255, 255, 0.3), inset -2px -2px 4px rgba(0, 0, 0, 0.3)',
      animation: 'blinkOrange 1.5s ease-in-out infinite',
      animationDelay: `${delay}s`,
      position: 'relative',
      border: '1px solid rgba(255, 165, 0, 0.5)',
      background: 'radial-gradient(circle at 30% 30%, #ffcc66, #ffa500, #cc8500)'
    };
  }

  try {
    const now = new Date();
    const loginDate = new Date(lastLogin);
    
    // التحقق من صحة التاريخ
    if (isNaN(loginDate.getTime())) {
      console.error('Invalid login date:', lastLogin);
      // إذا كان التاريخ غير صحيح، نعامل كأنه لم يدخل أبداً
      return {
        display: 'inline-block',
        width: '8px',
        height: '8px',
        backgroundColor: '#ffa500',
        borderRadius: '50%',
        marginLeft: '8px',
        boxShadow: 
          '0 0 8px #ffa500, 0 0 16px #ffa500, inset 2px 2px 4px rgba(255, 255, 255, 0.3), inset -2px -2px 4px rgba(0, 0, 0, 0.3)',
        animation: 'blinkOrange 1.5s ease-in-out infinite',
        animationDelay: `${delay}s`,
        position: 'relative',
        border: '1px solid rgba(255, 165, 0, 0.5)',
        background: 'radial-gradient(circle at 30% 30%, #ffcc66, #ffa500, #cc8500)'
      };
    }

    // حساب الفرق بالمللي ثانية ثم تحويله إلى ساعات
    const timeDiffMs = now.getTime() - loginDate.getTime();
    const hoursDiff = timeDiffMs / (1000 * 60 * 60);

    // إضافة debugging
    console.log('Login Debug:', {
      lastLogin,
      loginDate: loginDate.toISOString(),
      now: now.toISOString(),
      hoursDiff: hoursDiff.toFixed(2),
      isWithin24Hours: hoursDiff <= 24
    });

    if (hoursDiff <= 24) {
      // خضراء إذا لم يمر أكثر من 24 ساعة
      return {
        display: 'inline-block',
        width: '8px',
        height: '8px',
        backgroundColor: '#00ff00',
        borderRadius: '50%',
        marginLeft: '8px',
        boxShadow: 
          '0 0 8px #00ff00, 0 0 16px #00ff00, inset 2px 2px 4px rgba(255, 255, 255, 0.3), inset -2px -2px 4px rgba(0, 0, 0, 0.3)',
        animation: 'blinkGreen 1.2s ease-in-out infinite',
        animationDelay: `${delay}s`,
        position: 'relative',
        border: '1px solid rgba(0, 255, 0, 0.5)',
        background: 'radial-gradient(circle at 30% 30%, #66ff66, #00ff00, #00cc00)'
      };
    } else {
      // حمراء إذا مر أكثر من 24 ساعة
      return {
        display: 'inline-block',
        width: '8px',
        height: '8px',
        backgroundColor: '#ff0000',
        borderRadius: '50%',
        marginLeft: '8px',
        boxShadow: 
          '0 0 8px #ff0000, 0 0 16px #ff0000, inset 2px 2px 4px rgba(255, 255, 255, 0.3), inset -2px -2px 4px rgba(0, 0, 0, 0.3)',
        animation: 'blinkRed 0.8s ease-in-out infinite',
        animationDelay: `${delay}s`,
        position: 'relative',
        border: '1px solid rgba(255, 0, 0, 0.5)',
        background: 'radial-gradient(circle at 30% 30%, #ff6666, #ff0000, #cc0000)'
      };
    }
  } catch (error) {
    console.error('Error processing login date:', error, lastLogin);
    // في حالة حدوث خطأ، نعامل كأنه لم يدخل أبداً
    return {
      display: 'inline-block',
      width: '8px',
      height: '8px',
      backgroundColor: '#ffa500',
      borderRadius: '50%',
      marginLeft: '8px',
      boxShadow: 
        '0 0 8px #ffa500, 0 0 16px #ffa500, inset 2px 2px 4px rgba(255, 255, 255, 0.3), inset -2px -2px 4px rgba(0, 0, 0, 0.3)',
      animation: 'blinkOrange 1.5s ease-in-out infinite',
      animationDelay: `${delay}s`,
      position: 'relative',
      border: '1px solid rgba(255, 165, 0, 0.5)',
      background: 'radial-gradient(circle at 30% 30%, #ffcc66, #ffa500, #cc8500)'
    };
  }
};
